'use client';

import { c as _c } from "react/compiler-runtime";
import { MyMenuFaq } from '@module/svg/icons';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import { useRouter } from 'next/navigation';
import type { ReactNode } from 'react';
function FaqMenuItem(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = () => router.push("/customer/faq");
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MyMenuFaq className="mr-5 h-5 w-5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t1) {
    t3 = <div className="rounded-[10px] hover:bg-colorBg03"><DropdownMenuItem onClick={t1} className="w-fit cursor-pointer px-[10px]">{t2}{children}</DropdownMenuItem></div>;
    $[3] = children;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default FaqMenuItem;